export const decodeSpecialChars = value => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(value, 'text/html');
  const decodedString = doc.documentElement.textContent.replace(
    /(<([^>]+)>)/gi,
    ''
  );
  return decodedString.replace(/\\/g, '');
};
